export default function WhyUsSection() {
  const features = [
    {
      icon: 'ri-flashlight-line',
      title: '极速加载',
      description: '采用先进的CDN加速技术，视频秒开不缓冲，给你丝滑观影体验。',
    },
    {
      icon: 'ri-4k-line',
      title: '超清画质',
      description: '支持1080P超清画质，画面清晰细腻，让每一帧都成为享受。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端同步',
      description: '手机、平板、电脑无缝切换，随时随地想看就看。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠',
      description: '严格的内容审核机制，绿色健康的内容环境，放心观看。',
    },
    {
      icon: 'ri-notification-3-line',
      title: '追剧提醒',
      description: '收藏喜欢的剧集，更新第一时间通知，不错过每一集。',
    },
    {
      icon: 'ri-heart-line',
      title: '个性化推荐',
      description: '智能算法分析你的观影偏好，精准推荐你可能喜欢的内容。',
    },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            为什么选择桔子视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[500px] mx-auto">
            六大优势，打造极致观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-6 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}